<template>
<div>
  <v-data-table
    :loading="isLoading"
    :headers="headers"
    :items="dataTable"
    :items-per-page="itemPerPage"
    :page="tablePage"
    :footer-props="{'items-per-page-options': [5,10, 100]}"
    :search="search"
    :hide-default-header="true"
    :custom-filter="customFilter"
    no-results-text="查無符合資料"
    class="elevation-1"
  >
    <template v-slot:header="{props}">
      <thead class="v-data-table-header">
        <tr>
          <th
            v-for="(header, idx) in props.headers"
            :key="`header-${idx}-`+header.text"
            v-show="header.showInMobile || !isMobile"
            :style="{'cursor': header.sortKey ? 'pointer':'initial'}"
            @click="toggleSort(header)"
          >
            <span>{{ header.text }}</span>
            <v-chip
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0"
              x-small
              style="width: 16px;padding: 0 4px;"
            >{{sorting[header.sortKey].index}}</v-chip>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'desc'"
              x-small
            >mdi-arrow-down</v-icon>
            <v-icon
              v-if="header.sortKey"
              v-show="sorting[header.sortKey].index > 0 && sorting[header.sortKey].order == 'asc'"
              x-small
            >mdi-arrow-up</v-icon>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{pageTitle}}</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider>
        <span class="d-none d-sm-flex">權限: 主管以上</span> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="delaySearch"
          @input="onDelaySearchInput"
          append-icon="search"
          label="搜尋名稱、帳號"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>

        <v-tooltip
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              dark
              class="mb-2 ml-1 mr-1"
              small
              @click.stop="isShowFilterDialog = true"
            >
              <v-badge color="primary" v-if="filterConditionCount > 0">
                <template v-slot:badge><span primary>{{filterConditionCount}}</span></template>
                <v-icon x-small>mdi-filter-menu</v-icon>
              </v-badge>
              <v-icon v-else x-small>mdi-filter-menu</v-icon>
            </v-btn>
          </template>
          <span>進階篩選</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-btn
          v-if="myLevel>=10"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="exportExcel"
        >
          <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-btn
          v-if="canEditUser"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click.stop="isShowDialog = true;editingId=-1"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <user-addedit-dialog
          v-model="isShowDialog"
          :editing-id="editingId"
          @updated="onDataUpdated"
          :persistent="true"
        />

      </v-toolbar>
    </template>

    <template v-slot:item="{item}">
      <user-list-item
        :item="item"
        :key="`item-${item.ID}`"
        @edit="showEditDialog"
        @remove="deleteItem"
        @reset="resetItem"
      />
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="reloadDataTable"
      >Reset</v-btn>
    </template>
  </v-data-table>

  <user-detail-dialog
    v-model="isShowDetail"
    :id="watchingUserID"
    @close="closeUserDialog"
  />

  <user-filter-dialog
    v-model="isShowFilterDialog"
    :filter-condition="filterCondition"
    @updated="onFilterUpdated"
  />

  <v-snackbar
    v-model="isDataRefetched"
    :timeout="-1"
  >
    偵測到資料已更新
    <v-btn
      class="ml-1 mr-1"
      color="pink"
      text
      @click="isDataRefetched = false"
    >
      關閉
    </v-btn>
    <v-btn
      class="ml-1 mr-1"
      color="white"
      text
      @click="reloadDataTable"
    >
      重新載入
    </v-btn>
  </v-snackbar>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import UserAddeditDialog from "@/ui/management/user/user-addedit-dialog.vue";
import UserDetailDialog from "@/ui/management/user/user-detail-dialog.vue";
import UserListItem from "./user-list-item.vue";
import XMLGenerator from "@/data/excel/xml-generator-user.js";
import XLSXSaver from "@/data/excel/xlsx-saver.js";
// filter
import UserFilterDialog from "./user-filter-dialog.vue";
import advanceFilterMixin from "@/utils/mixin-vuetify-datatable-filter.vue";
// sorting
import sortingMixin from "@/utils/mixin-vuetify-datatable-sorting.vue";

import mixinDelaySearch from "@/ui/mixin-datatable-delaysearch.vue";
export default {
  mixins: [advanceFilterMixin, sortingMixin, mixinDelaySearch],
  components: {
    UserAddeditDialog,
    UserDetailDialog,
    UserListItem,
    UserFilterDialog
  },

  data: () => ({
    isLoading: false,
    // data table
    dataTable: [],
    pageTitle: "人員",
    itemPerPage: 10, // -1 is all, default is 10, 5 is fine.
    tablePage: 1,
    search: "",
    // addedit
    isShowDialog: false,
    editingId: -1,
    // view
    isShowDetail: false,
    watchingUserID: null,
    // data refetched
    isDataRefetched: false,
    // sorting
    sorting: {
      department: {
        order: null,
        index: -1
      }
    },
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    headers() {
      let actionHeader = {
        text: "操作",
        value: "action",
        showInMobile: true
      };
      return [
        { text: "人員名稱", value: "Name", showInMobile: true },
        { text: "帳號", value: "Username" },
        { text: "部門", value: "Department", sortKey: "department" },
        { text: "職位", value: "Position" },
        { text: "剩餘補休", value: "-" }
      ].concat(this.canEditUser ? [actionHeader] : []);
    },
    ...mapGetters(["canEditUser", "myLevel", "userDepartments"])
  },
  methods: {
    exportExcel() {
      let datas = this.dataTable.filter(
        o =>
          !this.search ||
          o.Profile.Name.includes(this.search) ||
          o.Username.includes(this.search)
      );
      let result = XMLGenerator.generate(this, datas);
      

      var fileName = window.prompt(
        "請輸入匯出Excel檔之名稱",
        "傳動ERP-使用者-匯出"
      );
      if (!fileName) {
        window.alert("請輸入檔案名稱");
        return;
      }
      XLSXSaver.saveAs(result, fileName);
    },
    customFilter(value, search, o) {
      return !search ||
          o.Profile.Name.includes(search) ||
          o.Username.includes(search)
    },
    showEditDialog(itemID) {
      this.editingId = itemID;
      this.isShowDialog = true;
    },
    deleteItem(item) {
      const removingIdx = this.$store.state.user.list.indexOf(item);

      this.isLoading = true;
      this.$services.user
        .inActivate(this, item.ID)
        .then(res => {
          this.$store.state.user.list[removingIdx].IsActive = false;
          this.$store.state.user.list[removingIdx].Username = `${item}-deleted`;
          // this.$alertMessage("成功刪除人員「" + item.Profile.Name + "」!");
          this.reloadDataTable();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetItem(item) {
      this.isLoading = true;
      this.$services.user
        .resetPassword(this, item.ID)
        // .then(res => {
        //   this.$alertMessage(
        //     "成功重設人員「" + item.Profile.Name + "」的密碼!"
        //   );
        // })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDataList () {
      var dataList = this.$store.state.user.list.filter(o => o.IsActive);

      const findUserDepartmentID = userID =>
        (this.$store.getters.userDepartments.find(o => o.UserID == userID) || {})
          .DepartmentID;

      const filter = o => {
        // if (this.filterCondition.ProjectID && findTaskWorkingItemProjectID(o) != this.filterCondition.ProjectID) return false;
        if (this.filterCondition.DepartmentID && findUserDepartmentID(o.ID) != this.filterCondition.DepartmentID) return false;
        // if (this.filterCondition.UserID && o.UserID != this.filterCondition.UserID) return false;
        // if (!!(this.filterCondition.Date) && !moment(this.filterCondition.Date).isSame(o.Date, "date")) return false;
        return true
      }

      const sortingFunc = (o1, o2) => {
        var result = 0;
        // 依據 this.sortings 修改排序
        for (let sorting of this.sortings) {
          if (sorting.key == "department") {
            let o1Value = findUserDepartmentID(o1.ID)
            let o2Value = findUserDepartmentID(o2.ID)
            if (sorting.order == "asc") result = o1Value - o2Value;
            else result = o2Value - o1Value;
          } else {
            window.console.error(`sortingFunc, unknown key ${sorting.key}`);
          }
          if (result != 0) break;
        }
        return result;
      };

      dataList = dataList.filter(filter)
      if (this.sortings.length) dataList = dataList.sort(sortingFunc);
      return dataList
    },
    reloadDataTable() {
      this.dataTable = this.getDataList()
      this.isDataRefetched = false;
      this.$store.state.user.isReloaded = false;
      this.tablePage = 1
    },
    onDataUpdated(item) {
      // let action = this.editingId >= 0 ? "編輯" : "新增";
      // this.$alertMessage(
      //   "成功" + action + "人員「" + item.Profile.Name + "」!"
      // );
      this.reloadDataTable();
    },
    showUserDialog(id) {
      this.isShowDetail = true;
      this.watchingUserID = id;
    },
    closeUserDialog() {
      this.isShowDetail = false;
    }
  },
  created() {
    if (this.myLevel < 10) {
      alert("沒有權限");
      this.$router.push({ name: "main" });
      return;
    }
    this.isLoading = true;

    let promiseList = [this.$services.department.prepareData(this)];

    let p1 = this.$services.prepareDatas(this);
    p1.then(this.reloadDataTable);
    promiseList.push(p1);
    promiseList.push(p1);
    Promise.all(promiseList).then(() => {
      this.isLoading = false;
    });

    let id = parseInt(this.$route.query.id || 0);
    if (id > 0) {
      this.showUserDialog(id);
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.id != from.query.id) {
        let id = parseInt(to.query.id || 0);
        if (id > 0) {
          this.showUserDialog(id);
        } else {
          this.isShowDetail = false;
        }
      }
    },
    isShowDetail() {
      if (
        !this.isShowDetail &&
        this.$route.query.id &&
        this.$route.name == "user-list"
      ) {
        this.$router.push({ name: "user-list" });
      }
    },
    "$store.state.user.isReloaded"() {
      if (this.$store.state.user.isFetched && this.$store.state.user.isReloaded)
        this.isDataRefetched = true;
    }, search () {
      this.tablePage = 1
    }
  }
};
</script>